/**
 * EF Precise Control — sync mobile underline tabs + desktop cards with media panels.
 */
(function () {
  var SECTION_SEL = '[data-ef-precise-control]';

  function initSection(root) {
    if (!root || root.dataset.efPreciseInit === '1') return;
    root.dataset.efPreciseInit = '1';

    var mobileTabs = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-precise-tab]')
    );
    var desktopCards = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-precise-card]')
    );
    var panels = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-precise-panel]')
    );
    var notes = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-precise-note]')
    );

    if (!panels.length) return;
    if (!mobileTabs.length && !desktopCards.length) return;

    var activeIndex = 0;

    function setActive(index, opts) {
      opts = opts || {};
      if (index < 0 || index >= panels.length) return;
      activeIndex = index;

      mobileTabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      desktopCards.forEach(function (card, i) {
        var on = i === index;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-selected', on ? 'true' : 'false');
        card.setAttribute('tabindex', on ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      notes.forEach(function (note, i) {
        var on = i === index;
        note.classList.toggle('is-active', on);
        if (on) {
          note.removeAttribute('hidden');
        } else {
          note.setAttribute('hidden', '');
        }
      });

      if (opts.scrollTab) {
        var tabEl = mobileTabs[index];
        if (tabEl && typeof tabEl.scrollIntoView === 'function') {
          tabEl.scrollIntoView({
            behavior: opts.instant ? 'auto' : 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }
    }

    function bindControls(nodes) {
      nodes.forEach(function (el, i) {
        el.addEventListener('click', function () {
          setActive(i, { scrollTab: true });
        });

        el.addEventListener('keydown', function (e) {
          var next = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i + 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = panels.length - 1;
          if (next < 0 || next >= panels.length) return;
          e.preventDefault();
          setActive(next, { scrollTab: true });
          var focusTarget = nodes[next] || mobileTabs[next] || desktopCards[next];
          if (focusTarget) focusTarget.focus();
        });
      });
    }

    bindControls(mobileTabs);
    bindControls(desktopCards);
    setActive(0, { instant: true });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SEL).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector(SECTION_SEL);
    if (root) {
      delete root.dataset.efPreciseInit;
      initSection(root);
    }
  });
})();
